module.exports = __webpack_public_path__ + "media/images/landing/fliist_logo_ru-1345e7a8eac22d52b3e08286ea60d0cf.png";